// eslint-disable-next-line import/no-cycle
import {
  TEMPLATE_COLUMN_IDENTIFIER_PREFIX,
  TEMPLATE_LINE_IDENTIFIER_PREFIX,
  TEMPLATE_WIDGET_IDENTIFIER_PREFIX,
  TEMPLATE_TRANSLATE_SPECIFIC,
  TEMPLATE_TRANSLATE_SPECIFIC_ITEMS,
  TEMPLATE_TRANSLATE_SPECIFIC_ONLY_ATTRIBUTE,
  TEMPLATE_TRANSLATE_SPECIFIC_ONLY_CONTENT,
  TEMPLATE_TRANSLATE_SPECIFIC_HTML_CONTENT,
  WIDGETS_PLACEHOLDER_IDENTIFIER,
} from '@/components/template-builder/utils/constants';
// eslint-disable-next-line import/no-cycle
import {
  createInputCheckboxRadioOption,
  createSelectOption,
  generateUniqStructureId,
} from '@/components/template-builder/utils/helpers';
import { countriesList } from '@/components/template-builder/utils/countries-list';
// eslint-disable-next-line import/no-cycle
import { WidgetTypeEnum } from '@/types';
import { faArrowToBottom } from '@/components/template-builder/utils/icons-definition';
// eslint-disable-next-line import/no-cycle
import { i18n } from '@/i18n';

// structures
export const rawWidgetPlaceholder = () => `<div class="${WIDGETS_PLACEHOLDER_IDENTIFIER}">${faArrowToBottom}</div>`;

export const rawColumn = () => {
  const columnId = `${TEMPLATE_COLUMN_IDENTIFIER_PREFIX}_${generateUniqStructureId()}`;
  return `<div class="spm_column spm_droppable_widget spm_droppable" style="width: calc(50% - 1.5px);" id="${columnId}">${rawWidgetPlaceholder()}</div>`;
};

export const rawLine = () => {
  const lineId = `${TEMPLATE_LINE_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<div id="${lineId}" class="spm_draggable_row spm_row"><div class="spm_columns">${rawColumn()}</div></div>`;
};

export const rawPrivacyPolicy = (t: Function) => {
  const lineId = `${TEMPLATE_LINE_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const columnId = `${TEMPLATE_COLUMN_IDENTIFIER_PREFIX}_${generateUniqStructureId()}`;
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const text = t('templateBuilder.privacyPolicy');

  return `<div class="spm_draggable_row spm_row spm_responsive" id="${lineId}">
    <div class="spm_columns">
      <div class="spm_column spm_droppable_widget spm_droppable ui-sortable" id="${columnId}">
        <div id="${widgetId}" class="spm_widget_display_text spm_draggable_widget spm_widget" data-widgettype="spm_widget_display_text" style="display: block;">
          <div class="spm_rich_editor">
            <a class="${TEMPLATE_TRANSLATE_SPECIFIC_HTML_CONTENT}" href="{var=shop.privacy_policy_url}">${text}</a>
          </div>
        </div>
      </div>
    </div>
  </div>`;
};

// widgets
const rawWidgetSeparator = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<div id="${widgetId}" class="spm_widget_display_separator spm_draggable_widget spm_widget"
    data-widgettype="spm_widget_display_separator"><hr class="spm_display_separator" /></div>`;
};

export const rawWidgetText = (text = `<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ultricies lectus egestas nulla mollis cursus.
  Sed nec lectus non nulla auctor aliquam. <br /><br /> Mauris facilisis at lectus nec consequat.
  Donec at condimentum turpis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>`) => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<div id="${widgetId}" class="spm_widget_display_text spm_draggable_widget spm_widget"
    data-widgettype="spm_widget_display_text"><div class="spm_rich_editor">${text}</div></div>`;
};
export const rawWidgetDisclosure = (text = (i18n.global as any).t('templateBuilder.fields.disclosureDefaultMessages.email')) => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<div id="${widgetId}" class="spm_widget_disclosure spm_draggable_widget spm_widget"
    data-widgettype="spm_widget_disclosure" data-disclosure-channels=""><div class="spm_rich_editor">${text}</div></div>`;
};
export const rawWidgetTitle = (text = 'Votre titre ici') => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<div id="${widgetId}" class="spm_widget_display_title spm_draggable_widget spm_widget"
    data-widgettype="spm_widget_display_title"><h1 class="spm_inline_editing">${text}</h1></div>`;
};

const rawWidgetImage = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const src = 'http://media.shopimind.io/img/v4/placeholders/image_placeholder.png';
  return `<div id="${widgetId}" class="spm_widget_display_image spm_draggable_widget spm_widget"
  data-widgettype="spm_widget_display_image">
    <a href="{var=shop.url}">
      <img src="${src}" width="100%" alt="">
    </a>
  </div>`;
};

const rawWidgetCode = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<div id="${widgetId}" class="spm_widget_display_code spm_draggable_widget spm_widget"
    data-widgettype="spm_widget_display_code"><p>Insert your own HTML code</p></div>`;
};

const rawWidgetJavascript = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<div id="${widgetId}" class="spm_widget_display_javascript spm_draggable_widget spm_widget"
    data-widgettype="spm_widget_display_javascript"><script type="text/javascript">
(function () {
  // Your code here
})();
</script></div>`;
};

const rawWidgetButton = ({ customLabel = 'Votre text ici', customHref = '{var=shop.url}' }) => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<div id="${widgetId}" class="spm_display_call_to_action spm_draggable_widget spm_widget"
    data-widgettype="spm_display_call_to_action">
    <a href="${customHref}" class="spm_inline_editing spm_button spm_div_align_center">${customLabel}</a></div>`;
};

const rawWidgetSocialMedia = (additionalConfiguration: Record<string, any>) => () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  let socialNetworksHtml = '';

  if (!additionalConfiguration.socialNetworks || !Array.isArray(additionalConfiguration.socialNetworks)) {
    // eslint-disable-next-line no-param-reassign
    additionalConfiguration.socialNetworks = [];
  }
  if ('socialNetworks' in additionalConfiguration && additionalConfiguration.socialNetworks && Array.isArray(additionalConfiguration.socialNetworks)) {
    if (additionalConfiguration.socialNetworks.length === 0) {
      additionalConfiguration.socialNetworks.push('facebook');
      additionalConfiguration.socialNetworks.push('twitter');
      additionalConfiguration.socialNetworks.push('email');
    }

    additionalConfiguration.socialNetworks.forEach((network: string) => {
      const variable = network === 'email' ? 'contact' : network;
      socialNetworksHtml += `<span class="spm_${network} spm_social_icon_container spm_social_icon">
        <a class="${TEMPLATE_TRANSLATE_SPECIFIC_ONLY_ATTRIBUTE}" href="{var=social.${variable}_url}">
        <img src="https://media.shopimind.io/img/icons/socialv2/2/${network}.png" alt="${network}" width="32" style="max-width:32px;" />
        </a>
      </span>`;
    });
  }

  return `<div id="${widgetId}" class="spm_widget_display_follow spm_draggable_widget spm_widget ${TEMPLATE_TRANSLATE_SPECIFIC}" data-widgettype="spm_widget_display_follow">
    <div class="spm_social_icons spm_social_icons_horizontal">${socialNetworksHtml}</div></div>`;
};

const rawWidgetVoucher = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<div id="${widgetId}" class="spm_widget_display_voucher spm_draggable_widget spm_widget ${TEMPLATE_TRANSLATE_SPECIFIC}" data-widgettype="spm_widget_display_voucher">
    <div class="spm_triggered_button spm_generate_voucher_button spm_with_icon spm_div_align_center">
      <div class="spm_container_voucher_button">
        <a href="javascript:void(0);" class="spm_generate_voucher spm_button spm_inline_editing" onclick="{var=voucher.button}"><i class="spm_voucher_icon spm_voucher_icon_inside spm_icon-gift-2"></i>Voir mon code de réduction</a>
      </div>
      <div class="spm_container_voucher_code spm_hidden">
        <a class="spm_voucher spm_button" href="javascript:void(0)"><i class="spm_voucher_icon_code spm_voucher_icon_inside spm_icon-gift-2"></i>SPM-XXXX</a>
      </div>
    </div>
  </div>`;
};

const rawWidgetSmartProductList = (t: Function) => () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<div id="${widgetId}" class="spm_smart_products_list spm_draggable_widget spm_widget" data-widgettype="spm_smart_products_list">
    <div class="spm_title_wrapper spm_product_list_title_wrapper">
      <h1 class="spm_product_list_title spm_inline_editing">${t('templateBuilder.smartProductListDefaultTitle')}</h1>
    </div>
    <div class="spm_product_list spm_product_list_horizontal_3">
      <div class="spm_product_list_element_container">
        <div class="spm_product_list_element_row">
          <div class="spm_product_list_element spm_product_list_element_wrapper"
            s-collection="products" s-item="product" s-grid="3" s-nb="3" s-engine="crossselling"
            s-ids="" s-excluded_ids="" s-excluded_categories="" s-excluded_manufacturers="" s-nb_weeks="4">
            <h4 class="spm_product_list_element_title"><a href="{var=product.url}" title="{var=product.name}">{var=product.name truncate="40"}</a></h4>
            <div class="spm_product_list_element_image_wrapper" style="text-align:center;margin:0;padding:0;">
              <a href="{var=product.url}">
                <img src="{var=product.image_url resize=400x400 resizeType=fill-to-fit}"
                width="150" class="spm_product_list_element_image" alt="{var=product.name}" title="{var=product.name}" />
              </a>
            </div>
            <div class="spm_product_list_element_description spm_hide_on_builder" style="height:70px;">
              <p>{var=product.description_short truncate="80"}</p>
            </div>
            <div class="spm_product_list_element_prices">
              <div s-if="product.price_strike" s-condition="!=" s-value="product.price" class="spm_product_list_element_price_strike_wrapper" style="text-align: center;">
                <p class="spm_product_list_element_price_strike">{var=product.price_strike}</p>
              </div>
              <div class="spm_product_list_element_price_wrapper" style="text-align: center;">
                <p class="spm_product_list_element_price">{var=product.price}</p>
              </div>
            </div>
            <div class="spm_product_list_element_button">
              <a href="{var=product.url}" class="spm_button spm_product_list_element_button" title="${t('templateBuilder.smartProductListDefaultButton')}">${t('templateBuilder.smartProductListDefaultButton')}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>`;
};

const rawWidgetCreateAccount = (t: Function) => () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<div id="${widgetId}" class="spm_widget_display_form_registration spm_draggable_widget spm_widget ${TEMPLATE_TRANSLATE_SPECIFIC}" data-widgettype="spm_form_registration">
    <div class="spm_form spm_action_displayMessage">
      <div class="spm_step1">
          <form name="spm_form_registration" class="spm_form_registration spm_label_inside">
              <div class="spm_form_field spm_form_field_base">
                  <label for="spm_form_registration_last_name">
                    <span class="${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}">
                      ${t('templateBuilder.fields.lastname')} :
                    </span>
                    <i class="required_asterisk">*</i>
                  </label>
                  <input type="text" id="spm_form_registration_last_name" name="spm_form_registration_last_name"
                    class="spm_form_input spm_form_required ${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}"
                    placeholder="${t('templateBuilder.fields.lastname')}" />
              </div>
              <div class="spm_form_field spm_form_field_base">
                  <label for="spm_form_registration_first_name">
                    <span class="${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}">
                      ${t('templateBuilder.fields.firstname')} :
                    </span>
                    <i class="required_asterisk">*</i>
                  </label>
                  <input type="text" id="spm_form_registration_first_name" name="spm_form_registration_first_name"
                    class="spm_form_input spm_form_required ${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}"
                    placeholder="${t('templateBuilder.fields.firstname')}" />
              </div>
              <div class="spm_form_field spm_form_field_base">
                  <label for="spm_form_registration_email">
                    <span class="${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}">
                      ${t('templateBuilder.fields.email')} :
                    </span>
                    <i class="required_asterisk">*</i>
                  </label>
                  <input type="text" id="spm_form_registration_email" name="spm_form_registration_email"
                    class="spm_form_input spm_form_required ${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}"
                    placeholder="${t('templateBuilder.fields.email')}" />
              </div>
              <div class="spm_form_field spm_form_field_base">
                  <label for="spm_form_registration_password">
                    <span class="${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}">
                      ${t('templateBuilder.fields.password')} :
                    </span>
                    <i class="required_asterisk">*</i>
                  </label>
                  <input type="password" id="spm_form_registration_password" name="spm_form_registration_password"
                    class="spm_form_input spm_form_required ${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}"
                    placeholder="${t('templateBuilder.fields.password')}" />
              </div>
              <div class="spm_form_field spm_hidden">
                  <label for="spm_form_registration_birthday">
                    <span class="${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}">
                      ${t('templateBuilder.fields.birthday')} :
                    </span>
                  </label>
                  <input type="text" id="spm_form_registration_birthday" name="spm_form_registration_birthday"
                    class="spm_form_input ${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}"
                    placeholder="${t('templateBuilder.fields.birthday')}" />
              </div>
              <div class="spm_form_field spm_form_checkbox spm_form_registration_field">
                  <input type="checkbox" id="spm_form_registration_newsletter" name="spm_form_registration_newsletter" class="spm_form_checkbox" />
                  <label for="spm_form_registration_newsletter" class="spm_force_inline ${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}">
                    ${t('templateBuilder.fields.registerNewsletter')}
                  </label>
              </div>
              <div class="spm_form_button">
                  <a href="javascript:void(0);" class="spm_inline_editing spm_button spm_div_align_center ${TEMPLATE_TRANSLATE_SPECIFIC_ONLY_CONTENT}"
                    onclick="shopimind.submitForm(spmFindAncestor(this, 'form'), 'registration', {var=template.id_template}, {var=id_step}, '{var=id_send}');"
                    >${t('templateBuilder.fields.validate')}</a>
              </div>
              <div class="spm_form_other_buttons">
                  <label class="${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}">${t('templateBuilder.fields.registerBy')}</label>
                  <div class="spm_socials_buttons">
                      <div class="spm_social_icons spm_social_icons_horizontal">
                          <span class="spm_facebook spm_social_icon_container spm_social_icon">
                              <a href="javascript:void(0);"
                                onclick="shopimind.formToUse = spmFindAncestor(this, 'form');
                                  window.open('https://proxima.shopimind.com/procedural_api/authApi.php?srv=fb');">
                                <img src="https://media.shopimind.io/img/icons/social/2/32/facebook.png" alt="Facebook" width="32" style="max-width:32px;" />
                              </a>
                          </span>
                      </div>
                  </div>
              </div>
              <div style="clear: both;"></div>
          </form>
      </div>
      <div class="spm_step2 spm_hidden"></div>
    </div>
  </div>`;
};

const rawWidgetNewsletterSubscription = (t: Function) => () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<div id="${widgetId}" class="spm_widget_display_form_newsletter spm_draggable_widget spm_widget ${TEMPLATE_TRANSLATE_SPECIFIC}" data-widgettype="spm_form_newsletter">
    <div class="spm_form spm_action_displayMessage">
      <div class="spm_step1">
        <form name="spm_form_newsletter" class="spm_form_newsletter spm_label_inside">
          <div class="spm_form_field spm_hidden">
            <label for="spm_form_registration_last_name"><span class="${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}">${t('templateBuilder.fields.lastname')}</span></label>
            <input type="text" id="spm_form_registration_last_name" name="spm_form_registration_last_name"
              class="spm_form_input ${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}"
              placeholder="${t('templateBuilder.fields.lastname')}" />
          </div>
          <div class="spm_form_field spm_hidden">
            <label for="spm_form_registration_first_name"><span class="${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}">${t('templateBuilder.fields.firstname')}</span></label>
            <input type="text" id="spm_form_registration_first_name" name="spm_form_registration_first_name"
              class="spm_form_input ${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}"
              placeholder="${t('templateBuilder.fields.firstname')}" />
          </div>
          <div class="spm_form_field spm_form_field_base spm_form_field_choosen">
            <label for="spm_form_registration_email">
              <span class="${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}">
                ${t('templateBuilder.fields.email')}
              </span>
              <i class="required_asterisk">*</i>
            </label>
            <input type="text" id="spm_form_registration_email" name="spm_form_registration_email"
              class="spm_form_input spm_form_required ${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}"
              placeholder="${t('templateBuilder.fields.email')}" />
          </div>
          <div class="spm_form_field spm_form_password spm_form_create_account_field spm_hidden">
            <label for="spm_form_registration_password">
              <span class="${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}">
                ${t('templateBuilder.fields.password')}
              </span>
              <i class="required_asterisk">*</i>
            </label>
            <input type="password" id="spm_form_registration_password" name="spm_form_registration_password"
              class="spm_form_input spm_form_required ${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}"
              placeholder="${t('templateBuilder.fields.password')}" />
          </div>
          <div class="spm_form_field spm_hidden">
            <label for="spm_form_registration_birthday"><span class="${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}">${t('templateBuilder.fields.birthday')}</span></label>
            <input type="text" id="spm_form_registration_birthday" name="spm_form_registration_birthday"
              class="spm_form_input ${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}"
              placeholder="${t('templateBuilder.fields.birthday')}" />
          </div>
          <div class="spm_form_button">
            <a href="javascript:void(0);" class="spm_inline_editing spm_button spm_div_align_center ${TEMPLATE_TRANSLATE_SPECIFIC_ONLY_CONTENT}"
              onclick="shopimind.submitForm(spmFindAncestor(this, 'form'), 'newsletter', {var=template.id_template}, {var=id_step}, '{var=id_send}');"
              >${t('templateBuilder.fields.validate')}</a>
          </div>
          <div class="spm_form_field spm_form_checkbox spm_form_create_account_field">
            <input type="checkbox" id="spm_form_registration_create_account" name="spm_form_registration_create_account" class="spm_form_checkbox" />
            <label for="spm_form_registration_create_account" class="spm_force_inline ${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}">${t('templateBuilder.fields.createAccount')}</label>
          </div>
          <div class="spm_form_other_buttons">
            <label class="${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}">${t('templateBuilder.fields.registerBy')}</label>
            <div class="spm_socials_buttons">
              <div class="spm_social_icons spm_social_icons_horizontal">
                <span class="spm_facebook spm_social_icon_container spm_social_icon">
                  <a href="javascript:void(0);"
                    onclick="shopimind.formToUse = spmFindAncestor(this, 'form'); window.open('https://proxima.shopimind.com/procedural_api/authApi.php?srv=fb');">
                    <img src="https://media.shopimind.io/img/icons/social/2/32/facebook.png" alt="Facebook" width="32" style="max-width:32px;" />
                  </a>
                </span>
              </div>
            </div>
          </div>
          <div style="clear: both;"></div>
        </form>
      </div>
      <div class="spm_step2 spm_hidden">

      </div>
    </div>
  </div>`;
};

const rawWidgetNewsletterUnsubscription = (t: Function) => () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<div
    id="${widgetId}"
    class="spm_widget_display_form_newsletter_unsubscribe spm_draggable_widget spm_widget ${TEMPLATE_TRANSLATE_SPECIFIC}"
    data-widgettype="spm_form_registration_unsubscribe">
      <div class="spm_form spm_action_displayMessage">
        <div class="spm_step1">
          <form name="spm_form_registration_unsubscribe" class="spm_form_registration_unsubscribe spm_label_inside">
            <div class="spm_form_field spm_form_field_base">
              <label for="spm_form_registration_email">
                <span class="${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}">
                  ${t('templateBuilder.fields.email')}
                </span>
                <i class="required_asterisk">*</i>
              </label>
              <input type="text" id="spm_form_registration_email" name="spm_form_registration_email"
                class="spm_form_input spm_form_required ${TEMPLATE_TRANSLATE_SPECIFIC_ITEMS}"
                placeholder="${t('templateBuilder.fields.email')}" />
            </div>
            <div class="spm_form_button">
              <a href="javascript:void(0);" class="spm_inline_editing spm_button spm_div_align_center ${TEMPLATE_TRANSLATE_SPECIFIC_ONLY_CONTENT}"
              onclick="shopimind.submitForm(spmFindAncestor(this, 'form'), 'newsletter_unsubscribe', {var=template.id_template}, {var=id_step}, '{var=id_send}');">
                ${t('templateBuilder.fields.validate')}
              </a>
            </div>
            <div style="clear: both;"></div>
          </form>
        </div>
        <div class="spm_step2 spm_hidden">

        </div>
      </div>
  </div>`;
};

const rawWidgetFacebookMessenger = (t: Function) => () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<div id="${widgetId}" class="spm_facebook_messenger spm_draggable_widget spm_widget ${TEMPLATE_TRANSLATE_SPECIFIC}" data-widgettype="spm_facebook_messenger">
    <img src="https://media.shopimind.io/img/facebook-checkbox-plugin/standard-light.png" id="fbMessengerCheckboxBuilder" />
    <div class="fb-messenger-checkbox" origin="{var=shop.root_url}" page_id="{var=shop.fb_pageid}"
      messenger_app_id="1951290961830126" user_ref="{var=visitor.fb_userref}" allow_login="true"
      size="standard" skin="light" center_align="false"
    ></div>
  </div>`;
};

export const rawColumnsLayout = (percentages: number[]) => {
  let html = '';

  percentages.forEach((percentage) => {
    const columnId = `${TEMPLATE_COLUMN_IDENTIFIER_PREFIX}_${generateUniqStructureId()}`;
    html += `<div class="spm_column spm_droppable_widget spm_droppable" style="width: calc(${percentage}% - 1.5px);" id="${columnId}">${rawWidgetPlaceholder()}</div>`;
  });

  return html;
};

export const rawLineWithColumns = (percentages: number[], columnsOnly = false) => {
  if (columnsOnly === true) {
    return rawColumnsLayout(percentages);
  }
  const lineId = `${TEMPLATE_LINE_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<div id="${lineId}" class="spm_draggable_row spm_row"><div class="spm_columns">${rawColumnsLayout(percentages)}</div></div>`;
};

/**
 * RAW INPUT WIDGETS
 */

export const rawInputText = (
  {
    customLabel = 'Libellé',
    customPlaceholder = 'Texte de remplissage',
    contactProperty = '',
    showLabel = false,
    required = false,
  },
) => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const containerClass = !showLabel ? 'spm_form_field spm_widget_input_text__container spm_label_inside' : 'spm_form_field spm_widget_input_text__container';
  return `
    <div
      id="${widgetId}"
      class="spm_widget_input_text spm_widget_form spm_draggable_widget spm_widget"
      data-widgettype="spm_widget_input_text"
      ${contactProperty ? `data-contactproperty="${contactProperty}"` : ''}
    >
      <div class="${containerClass}">
        <label class="spm_form_label spm_widget_input_text__label" for="spm_form_input_text--${widgetId}">${customLabel}</label>
        <input id="spm_form_input_text--${widgetId}" type="text" class="spm_widget_input_text__input" placeholder="${customPlaceholder}" autocomplete="off" ${required ? 'required' : ''} />
      </div>
    </div>
  `;
};

export const rawInputEmail = (
  {
    customLabel = 'Email',
    customPlaceholder = 'Email',
    contactProperty = 'email',
    showLabel = false,
    required = false,
  },
) => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const containerClass = !showLabel ? 'spm_form_field spm_widget_input_email__container spm_label_inside' : 'spm_form_field spm_widget_input_email__container';
  return `
    <div
      id="${widgetId}"
      class="spm_widget_input_email spm_widget_form spm_draggable_widget spm_widget"
      data-widgettype="spm_widget_input_email"
      data-contactproperty="${contactProperty}"
    >
      <div class="${containerClass}">
        <label class="spm_form_label spm_widget_input_email__label" for="spm_form_input_email--${widgetId}">${customLabel}</label>
        <input id="spm_form_input_email--${widgetId}" type="email" class="spm_widget_input_email__input" placeholder="${customPlaceholder}" autocomplete="off" ${required ? 'required' : ''} />
      </div>
    </div>
  `;
};

export const rawInputPhone = (
  {
    customLabel = 'Téléphone',
    customPlaceholder = 'Téléphone',
    contactProperty = 'phone_number',
    showLabel = false,
    defaultCountry = 'FR',
    required = false,
  },
) => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const containerClass = !showLabel ? 'spm_form_field spm_widget_input_phone__container spm_label_inside' : 'spm_form_field spm_widget_input_phone__container';
  return `
    <div
      id="${widgetId}"
      class="spm_widget_input_phone spm_widget_form spm_draggable_widget spm_widget"
      data-widgettype="spm_widget_input_phone"
      data-contactproperty="${contactProperty}"
      data-default-country="${defaultCountry}"
    >
      <div class="${containerClass}">
        <label class="spm_form_label spm_widget_input_phone__label" for="spm_form_input_phone--${widgetId}">${customLabel}</label>
        <div class="spm_widget_input_phone__input_container">
          <div class="spm_custom_select spm_widget_input_phone__country_select" data-country-select="${widgetId}">
            <div class="spm_custom_select__trigger">${
  (() => {
    const country = countriesList.find((c) => c.code === defaultCountry);
    return country ? `${country.flag} (${country.dialCode})` : '';
  })()
}</div>
            <div class="spm_custom_select__dropdown">
              <input type="text" class="spm_custom_select__search" placeholder="Rechercher..." />
              <div class="spm_custom_select__options">
                {var="countries.list"}
              </div>
            </div>
            <input type="hidden" class="spm_custom_select__hidden_input" value="${defaultCountry}" />
          </div>
          <input id="spm_form_input_phone--${widgetId}" type="tel" class="spm_widget_input_phone__input" placeholder="${customPlaceholder}" autocomplete="off" ${required ? 'required' : ''} />
        </div>
      </div>
    </div>
  `;
};

export const rawInputPassword = (
  {
    customLabel = 'Mot de passe',
    customPlaceholder = 'Mot de passe',
    showLabel = false,
    required = false,
  },
) => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const containerClass = !showLabel ? 'spm_form_field spm_widget_input_password__container spm_label_inside' : 'spm_form_field spm_widget_input_password__container';
  return `
    <div
      id="${widgetId}"
      class="spm_widget_input_password spm_widget_form spm_draggable_widget spm_widget"
      data-widgettype="spm_widget_input_password"
    >
      <div class="${containerClass}">
        <label class="spm_form_label spm_widget_input_password__label" for="spm_form_input_password--${widgetId}">${customLabel}</label>
        <input
          id="spm_form_input_password--${widgetId}"
          type="password"
          class="spm_widget_input_password__input"
          placeholder="${customPlaceholder}"
          ${required ? 'required' : ''}
        />
      </div>
    </div>
  `;
};

export const rawTextarea = (
  {
    customLabel = 'Libellé',
    customPlaceholder = 'Texte de remplissage',
    contactProperty = '',
    showLabel = false,
    required = false,
  },
) => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const containerClass = !showLabel ? 'spm_form_field spm_widget_textarea__container spm_label_inside' : 'spm_form_field spm_widget_textarea__container';
  return `
    <div
      id="${widgetId}"
      class="spm_widget_textarea spm_widget_form spm_draggable_widget spm_widget"
      data-widgettype="spm_widget_textarea"
      ${contactProperty ? `data-contactproperty="${contactProperty}"` : ''}
    >
      <div class="${containerClass}">
        <label class="spm_form_label spm_widget_textarea__label" for="spm_form_textarea--${widgetId}">${customLabel}</label>
        <textarea id="spm_form_textarea--${widgetId}" class="spm_widget_textarea__input" placeholder="${customPlaceholder}" autocomplete="off" ${required ? 'required' : ''}></textarea>
      </div>
    </div>
  `;
};

export const rawInputDate = (
  {
    customLabel = 'Libellé',
    customPlaceholder = 'Date',
    contactProperty = '',
    showLabel = false,
    required = false,
  },
) => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const containerClass = !showLabel ? 'spm_form_field spm_widget_input_date__container spm_label_inside' : 'spm_form_field spm_widget_input_date__container';
  return `
    <div
      id="${widgetId}"
      class="spm_widget_input_date spm_widget_form spm_draggable_widget spm_widget"
      data-widgettype="spm_widget_input_date"
      data-dateformat="JJ/MM/YYYY"
      ${contactProperty ? `data-contactproperty="${contactProperty}"` : ''}
    >
      <div class="${containerClass}">
        <label class="spm_form_label spm_widget_input_date__label" for="spm_form_input_date--${widgetId}">${customLabel}</label>
        <input id="spm_form_input_date--${widgetId}" type="date" class="spm_widget_input_date__input" placeholder="${customPlaceholder}" autocomplete="off" ${required ? 'required' : ''} />
      </div>
    </div>
  `;
};

export const rawConsentCheckbox = (t: Function, { contactProperty = 'consent_email' }) => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const channelMap: Record<string, string> = {
    consent_email: 'email',
    consent_sms: 'sms',
    consent_whatsapp: 'whatsapp',
  };
  const channel = channelMap[contactProperty] || 'email';
  const labelMap: Record<string, string> = {
    // Suivi (CNIL pixels) groupé activé par défaut sur email → libellé combiné par défaut
    email: t('templateBuilder.fields.consentDefaultLabels.email_tracking'),
    sms: t('templateBuilder.fields.consentDefaultLabels.sms'),
    whatsapp: t('templateBuilder.fields.consentDefaultLabels.whatsapp'),
  };
  const label = labelMap[channel] || labelMap.email;
  return `
    <div
      id="${widgetId}"
      class="spm_widget_consent_checkbox spm_widget_input_checkbox spm_widget_form spm_draggable_widget spm_widget"
      data-widgettype="spm_widget_consent_checkbox"
      data-contactproperty="${contactProperty}"
      data-consent-channel="${channel}"
      ${channel === 'email' ? 'data-tracking-consent="true"' : ''}
    >
      <div class="spm_form_field spm_widget_input_checkbox__container spm_label_inside">
        <label class="spm_form_label spm_widget_input_checkbox__label">${label}</label>
        <div class="spm_widget_input_checkbox__options-wrapper">
          <div class="spm_widget_input_checkbox__options-container">
            ${createInputCheckboxRadioOption(widgetId, 'checkbox', label, '', '1')}
          </div>
        </div>
      </div>
    </div>
  `;
};

export const rawInputCheckbox = ({ customLabel = 'Libellé', contactProperty = '', showLabel = true }) => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const containerClass = !showLabel ? 'spm_form_field spm_widget_input_checkbox__container spm_label_inside' : 'spm_form_field spm_widget_input_checkbox__container';
  return `
    <div
      id="${widgetId}"
      class="spm_widget_input_checkbox spm_widget_form spm_draggable_widget spm_widget"
      data-widgettype="spm_widget_input_checkbox"
      ${contactProperty ? `data-contactproperty="${contactProperty}"` : ''}
    >
      <div class="${containerClass}">
        <label class="spm_form_label spm_widget_input_checkbox__label">${customLabel}</label>
        <div class="spm_widget_input_checkbox__options-wrapper">
          <div class="spm_widget_input_checkbox__options-container">
            ${createInputCheckboxRadioOption(widgetId, 'checkbox', 'Option 1', '', '1')}
          </div>
        </div>
      </div>
    </div>
  `;
};

export const rawInputRadio = ({ customLabel = 'Libellé', contactProperty = '', showLabel = false }) => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const containerClass = !showLabel ? 'spm_form_field spm_widget_input_radio__container spm_label_inside' : 'spm_form_field spm_widget_input_radio__container';
  return `
    <div
      id="${widgetId}"
      class="spm_widget_input_radio spm_widget_form spm_draggable_widget spm_widget"
      data-widgettype="spm_widget_input_radio"
      ${contactProperty ? `data-contactproperty="${contactProperty}"` : ''}
    >
      <div class="${containerClass}">
        <label class="spm_form_label spm_widget_input_radio__label">${customLabel}</label>
        <div class="spm_widget_input_radio__options-wrapper">
          <div class="spm_widget_input_radio__options-container">
            ${createInputCheckboxRadioOption(widgetId, 'radio', 'Option 1', '', '1', false)}
          </div>
        </div>
      </div>
    </div>
  `;
};

export const rawInputSelect = ({
  customLabel = 'Libellé', customPlaceholder = 'Choisissez votre option', contactProperty = '', showLabel = false, required = false,
}) => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const containerClass = !showLabel ? 'spm_form_field spm_widget_input_select__container spm_label_inside' : 'spm_form_field spm_widget_input_select__container';
  return `
    <div
      id="${widgetId}"
      class="spm_widget_input_select spm_widget_form spm_draggable_widget spm_widget"
      data-widgettype="spm_widget_input_select"
      ${contactProperty ? `data-contactproperty="${contactProperty}"` : ''}
    >
      <div class="${containerClass}">
        <label class="spm_form_label spm_widget_input_select__label" for="spm_form_input_select--${widgetId}">${customLabel}</label>
        <div class="spm_custom_select spm_widget_input_select__input" id="spm_form_input_select--${widgetId}">
          <div class="spm_custom_select__trigger">
            <span class="spm_custom_select__value spm_custom_select__placeholder" data-selectoptionplaceholder="${customPlaceholder}">${customPlaceholder}</span>
            <span class="spm_custom_select__arrow"></span>
          </div>
          <div class="spm_custom_select__dropdown">
            <input type="text" class="spm_custom_select__search" placeholder="Rechercher..." />
            <div class="spm_custom_select__options">
              ${createSelectOption(widgetId, 'Option 1', '1', '1')}
            </div>
          </div>
          <input type="hidden" class="spm_custom_select__hidden_input" name="spm_form_input_select--${widgetId}" value="" ${required ? 'required' : ''} />
        </div>
      </div>
    </div>
  `;
};

// Game Wheel widget (Roue de la chance)
const rawWidgetGameWheel = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const defaultPrizes = JSON.stringify([
    { label: '-10%', probability: 25, color: '#FF6B6B' },
    { label: '-20%', probability: 20, color: '#4ECDC4' },
    { label: 'Livraison', probability: 25, color: '#45B7D1' },
    { label: '-5€', probability: 15, color: '#96CEB4' },
    { label: 'Perdu', probability: 10, color: '#DDA0DD' },
    { label: '-30%', probability: 5, color: '#FFEAA7' },
  ]);

  // Pre-rendered wheel SVG with 6 equal segments (60° each)
  const wheelSvg = `<svg class="spm_game_wheel_svg" viewBox="0 0 300 300">
    <defs>
      <filter id="wheelShadow2" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="0" dy="2" stdDeviation="3" flood-opacity="0.3"/>
      </filter>
    </defs>
    <g filter="url(#wheelShadow2)">
      <path d="M150,150 L150,10 A140,140 0 0,1 271.24,71.24 Z" fill="#FF6B6B"/>
      <path d="M150,150 L271.24,71.24 A140,140 0 0,1 290,150 Z" fill="#4ECDC4"/>
      <path d="M150,150 L290,150 A140,140 0 0,1 271.24,228.76 Z" fill="#45B7D1"/>
      <path d="M150,150 L271.24,228.76 A140,140 0 0,1 150,290 Z" fill="#96CEB4"/>
      <path d="M150,150 L150,290 A140,140 0 0,1 28.76,228.76 Z" fill="#DDA0DD"/>
      <path d="M150,150 L28.76,228.76 A140,140 0 0,1 10,150 Z" fill="#FFEAA7"/>
      <circle cx="150" cy="150" r="140" fill="none" stroke="#1a1a1a" stroke-width="8"/>
      <text x="185" y="55" fill="#fff" font-size="10" font-weight="bold" text-anchor="middle" transform="rotate(30,185,55)">10%</text>
      <text x="245" y="120" fill="#fff" font-size="10" font-weight="bold" text-anchor="middle" transform="rotate(90,245,120)">20%</text>
      <text x="245" y="180" fill="#fff" font-size="9" font-weight="bold" text-anchor="middle" transform="rotate(150,245,180)">Livraison</text>
      <text x="185" y="245" fill="#fff" font-size="10" font-weight="bold" text-anchor="middle" transform="rotate(210,185,245)">5€</text>
      <text x="115" y="245" fill="#fff" font-size="10" font-weight="bold" text-anchor="middle" transform="rotate(270,115,245)">Perdu</text>
      <text x="55" y="180" fill="#333" font-size="10" font-weight="bold" text-anchor="middle" transform="rotate(330,55,180)">30%</text>
      <circle cx="150" cy="150" r="25" fill="#ffffff" stroke="#1a1a1a" stroke-width="3"/>
    </g>
  </svg>`;

  return `<div id="${widgetId}" class="spm_widget_game_wheel spm_draggable_widget spm_widget"
    data-widgettype="spm_widget_game_wheel"
    data-prizes='${defaultPrizes}'
    data-display-mode="full"
    data-pointer-position="top"
    data-wheel-size="300"
    data-pointer-color="#1a1a1a"
    data-border-color="#1a1a1a"
    data-border-width="8"
    data-text-color="#ffffff"
    data-font-size="14"
    data-text-orientation="radial"
    data-spin-duration="4000"
    data-result-api-url="">
    <div class="spm_game_wheel_container">
      <div class="spm_game_wheel_wrapper">
        <div class="spm_game_wheel_pointer"></div>
        ${wheelSvg}
      </div>
    </div>
  </div>`;
};

// Game Slot Machine widget (Machine à sous)
const rawWidgetGameSlotMachine = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const defaultSymbols = JSON.stringify([
    { id: 'symbol_5pct', type: 'text', text: '5%', label: '5%' },
    { id: 'symbol_20pct', type: 'text', text: '20%', label: '20%' },
    { id: 'symbol_shipping', type: 'text', text: 'Livraison offerte', label: 'Livraison offerte' },
  ]);
  const defaultWinCombinations = JSON.stringify([
    { symbols: ['symbol_5pct', 'symbol_5pct', 'symbol_5pct'], prize: '5% de réduction', probability: 50 },
    { symbols: ['symbol_20pct', 'symbol_20pct', 'symbol_20pct'], prize: '20% de réduction', probability: 15 },
    { symbols: ['symbol_shipping', 'symbol_shipping', 'symbol_shipping'], prize: 'Livraison offerte', probability: 35 },
  ]);

  return `<div id="${widgetId}" class="spm_widget_game_slot_machine spm_draggable_widget spm_widget"
    data-widgettype="spm_widget_game_slot_machine"
    data-symbols="${defaultSymbols.replace(/"/g, '&quot;')}"
    data-win-combinations="${defaultWinCombinations.replace(/"/g, '&quot;')}"
    data-reels-count="3"
    data-reel-height="100"
    data-symbol-size="80"
    data-spin-duration="2000"
    data-frame-color="#1a1a1a"
    data-background-color="#ffffff"
    data-line-color="#ffd700"
    data-line-width="3"
    data-frame-radius="16"
    data-reel-radius="4"
    data-reel-gap="8"
    data-text-color="#333333"
    data-font-size="20"
    data-result-api-url="">
    <div class="spm_game_slot_machine_container">
      <div class="spm_game_slot_machine_frame">
        <div class="spm_game_slot_machine_reels spm_no_translate">
          <div class="spm_game_slot_reel" data-reel="0">
            <div class="spm_game_slot_symbol">5%</div>
          </div>
          <div class="spm_game_slot_reel" data-reel="1">
            <div class="spm_game_slot_symbol">20%</div>
          </div>
          <div class="spm_game_slot_reel" data-reel="2">
            <div class="spm_game_slot_symbol">Livraison offerte</div>
          </div>
        </div>
        <div class="spm_game_slot_machine_line"></div>
      </div>
    </div>
  </div>`;
};

// Game Scratch Card widget (Jeu à gratter)
const rawWidgetGameScratchCard = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const defaultPrizes = JSON.stringify([
    { label: '10% de réduction', probability: 30, image: '' },
    { label: '20% de réduction', probability: 25, image: '' },
    { label: 'Livraison gratuite', probability: 20, image: '' },
    { label: 'Perdu', probability: 25, image: '' },
  ]);

  return `<div id="${widgetId}" class="spm_widget_game_scratch_card spm_draggable_widget spm_widget"
    data-widgettype="spm_widget_game_scratch_card"
    data-prizes='${defaultPrizes}'
    data-card-width="320"
    data-card-height="220"
    data-cover-color="#b8860b"
    data-cover-image=""
    data-cover-image-size="cover"
    data-cover-image-position="center"
    data-cover-texture="true"
    data-cover-text-color="#ffffff"
    data-reveal-threshold="50"
    data-brush-size="30"
    data-background-color="#fffbf0"
    data-result-text-color="#b8860b"
    data-result-font-size="28"
    data-border-radius="16"
    data-border-color="#d4a017"
    data-border-width="3"
    data-result-api-url="">
    <div class="spm_game_scratch_card_container">
      <div class="spm_game_scratch_card_ticket">
        <div class="spm_game_scratch_card_wrapper">
          <div class="spm_game_scratch_card_cover">
            <img class="spm_game_scratch_card_cover_icon spm_no_translate" src="https://media.shopimind.io/clri/c-5994/ffc12a/69bd79f603eb5.png" alt="" />
            <span class="spm_game_scratch_card_cover_text ${TEMPLATE_TRANSLATE_SPECIFIC_ONLY_CONTENT}">Grattez ici !</span>
            <span class="spm_game_scratch_card_cover_hint ${TEMPLATE_TRANSLATE_SPECIFIC_ONLY_CONTENT}">Utilisez votre souris ou votre doigt</span>
          </div>
          <div class="spm_game_scratch_card_reveal spm_no_translate">
            <div class="spm_game_scratch_card_prize_wrapper">
              <span class="spm_game_scratch_card_prize_icon"></span>
              <p class="spm_game_scratch_card_prize">20% de réduction</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>`;
};

// Countdown widget
const rawWidgetCountdown = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  // Default end date: 1 day from now (relative)
  const defaultEndDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).toISOString();

  return `<div id="${widgetId}" class="spm_widget_countdown spm_draggable_widget spm_widget"
    data-widgettype="spm_widget_countdown"
    data-date-type="relative"
    data-end-date="${defaultEndDate}"
    data-timezone="UTC"
    data-relative-days="1"
    data-show-days="true"
    data-show-hours="true"
    data-show-minutes="true"
    data-show-seconds="true"
    data-expired-action="hide"
    data-expired-message="Offre expirée">
    <div class="spm_countdown_container">
      <div class="spm_countdown_item spm_countdown_days">
        <span class="spm_countdown_value spm_no_translate">00</span>
        <span class="spm_countdown_label ${TEMPLATE_TRANSLATE_SPECIFIC_ONLY_CONTENT}">Jours</span>
      </div>
      <div class="spm_countdown_item spm_countdown_hours">
        <span class="spm_countdown_value spm_no_translate">00</span>
        <span class="spm_countdown_label ${TEMPLATE_TRANSLATE_SPECIFIC_ONLY_CONTENT}">Heures</span>
      </div>
      <div class="spm_countdown_item spm_countdown_minutes">
        <span class="spm_countdown_value spm_no_translate">00</span>
        <span class="spm_countdown_label ${TEMPLATE_TRANSLATE_SPECIFIC_ONLY_CONTENT}">Minutes</span>
      </div>
      <div class="spm_countdown_item spm_countdown_seconds">
        <span class="spm_countdown_value spm_no_translate">00</span>
        <span class="spm_countdown_label ${TEMPLATE_TRANSLATE_SPECIFIC_ONLY_CONTENT}">Secondes</span>
      </div>
    </div>
  </div>`;
};

export const rawWidgets = (t: Function, additionalConfiguration: Record<string, any>): { [key: string]: () => string } => ({
  [WidgetTypeEnum.SEPARATOR]: rawWidgetSeparator,
  [WidgetTypeEnum.TEXT]: rawWidgetText,
  [WidgetTypeEnum.TITLE]: rawWidgetTitle,
  [WidgetTypeEnum.IMAGE]: rawWidgetImage,
  [WidgetTypeEnum.CODE]: rawWidgetCode,
  [WidgetTypeEnum.JAVASCRIPT]: rawWidgetJavascript,
  [WidgetTypeEnum.BUTTON]: () => rawWidgetButton(additionalConfiguration),
  [WidgetTypeEnum.SOCIAL_MEDIA]: rawWidgetSocialMedia(additionalConfiguration),
  [WidgetTypeEnum.VOUCHER]: rawWidgetVoucher,
  [WidgetTypeEnum.SMART_PRODUCT_LIST]: rawWidgetSmartProductList(t),
  // [WidgetTypeEnum.CREATE_ACCOUNT]: rawWidgetCreateAccount(t),
  // [WidgetTypeEnum.NEWSLETTER_SUBSCRIPTION]: rawWidgetNewsletterSubscription(t),
  // [WidgetTypeEnum.NEWSLETTER_UNSUBSCRIPTION]: rawWidgetNewsletterUnsubscription(t),
  [WidgetTypeEnum.FACEBOOK_MESSENGER]: rawWidgetFacebookMessenger(t),
  [WidgetTypeEnum.COLUMN]: () => '', // Empty string. Only used to display the widget in the panel. Code of widget is returned by getColumnsWidgetLayouts
  // Form widgets
  [WidgetTypeEnum.INPUT_TEXT]: () => rawInputText(additionalConfiguration),
  [WidgetTypeEnum.INPUT_EMAIL]: () => rawInputEmail(additionalConfiguration),
  [WidgetTypeEnum.INPUT_PHONE]: () => rawInputPhone(additionalConfiguration),
  [WidgetTypeEnum.INPUT_PASSWORD]: () => rawInputPassword(additionalConfiguration),
  [WidgetTypeEnum.TEXTAREA]: () => rawTextarea(additionalConfiguration),
  [WidgetTypeEnum.INPUT_DATE]: () => rawInputDate(additionalConfiguration),
  [WidgetTypeEnum.INPUT_CHECKBOX]: () => rawInputCheckbox(additionalConfiguration),
  [WidgetTypeEnum.CONSENT_CHECKBOX]: () => rawConsentCheckbox(t, additionalConfiguration),
  [WidgetTypeEnum.INPUT_RADIO]: () => rawInputRadio(additionalConfiguration),
  [WidgetTypeEnum.INPUT_SELECT]: () => rawInputSelect(additionalConfiguration),
  [WidgetTypeEnum.DISCLOSURE]: rawWidgetDisclosure,
  [WidgetTypeEnum.COUNTDOWN]: rawWidgetCountdown,
  // Game widgets
  [WidgetTypeEnum.GAME_WHEEL]: rawWidgetGameWheel,
  [WidgetTypeEnum.GAME_SLOT_MACHINE]: rawWidgetGameSlotMachine,
  [WidgetTypeEnum.GAME_SCRATCH_CARD]: rawWidgetGameScratchCard,
});
